import RootState from './RootState';
import {
    Module,
    ActionTree,
    ActionContext,
    GetterTree,
    MutationTree,
} from 'vuex';

export interface DistributorState {
    distributorId: string;
}

export const state: DistributorState = {
    // tslint:disable-next-line: triple-equals
    distributorId: '',
};

export const actions: ActionTree<DistributorState, RootState> = {
    saveDistributorId(
        context: ActionContext<DistributorState, RootState>,
        distributorId: string,
    ) {
        context.commit('setDistributorId', distributorId);
    },
};

export const getters: GetterTree<DistributorState, RootState> = {
    distributorId(state: DistributorState): string {
        return state.distributorId;
    },
};

export const mutations: MutationTree<DistributorState> = {
    setDistributorId(state: DistributorState, distributorId: string) {
        state.distributorId = distributorId;
    },
};

export const distributor: Module<DistributorState, RootState> = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
